import React from 'react';
import BaseModal from 'src/common/components/Modal';

const ConfirmFileModal = ({ open, onClose, onSuccess }) => {
	return (
		<BaseModal
			open={open}
			confirmLabel="Confirmar"
			onConfirm={() => onSuccess()}
			onClose={onClose}
			onCancel={onClose}
		>
			<div
				className="text-center mb-10  text-dark font-weight-bolder "
				style={{ fontSize: 17 }}
			>
				¿Desea realizar la precarga?
			</div>
		</BaseModal>
	);
};

export default ConfirmFileModal;
